import { Reveal } from "@/components/Reveal";
import { AnimatedCounter } from "@/components/AnimatedCounter";
import { STATS } from "@/data/content";

export function StatsSection() {
    return (
        <section className="bg-terracotta relative overflow-hidden" data-testid="stats-band">
            <div className="glow-sage absolute -top-28 right-8 w-[440px] h-[440px] pointer-events-none opacity-40" />
            <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10 py-14 lg:py-16">
                <div className="grid grid-cols-2 lg:grid-cols-4">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={i * 0.08}>
                            <div
                                className={`px-2 lg:px-8 py-4 lg:py-0 ${
                                    i === 0 ? "" : "lg:border-l lg:border-white/20"
                                }`}
                            >
                                <div className="font-heading text-4xl lg:text-6xl text-white leading-none">
                                    <AnimatedCounter value={s.value} />
                                </div>
                                <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/70 mt-3">
                                    {s.label}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
